import { classNames } from '@src/hylo-components/utils/usefull/usefull';
import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'kn-page-detail-sidebar-item',
})
export class KnPageDetailSidebarItem {
  @Prop() label: string;
  @Prop() variant: 'default' | 'sr-only' = 'default';

  render() {
    return (
      <Host
        class={classNames({
          'tw-flex tw-flex-col tw-gap-1': this.variant !== 'sr-only',
          'tw-sr-only': this.variant === 'sr-only',
        })}
        role="group"
      >
        {!!this.label && this.variant !== 'sr-only' && (
          <dt class="tw-shrink-0">
            <kn-page-detail-sidebar-heading>{this.label}</kn-page-detail-sidebar-heading>
          </dt>
        )}
        <dd>
          <slot></slot>
          {this.variant !== 'sr-only' && <hylo-sr-only>,</hylo-sr-only>}
        </dd>
      </Host>
    );
  }
}
